<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>Copy Extra</template>
    <v-row v-if="extras.length == 0">
      <v-col class="pb-0"
        ><v-text-field
          v-model="newName"
          label="New Name"
          :outlined="outlinedInputs"
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col class="pb-0">
        <v-select
          :items="selectableServices"
          v-model="selectedServiceIds"
          label="Copy to"
          item-text="name"
          item-value="id"
          :outlined="outlinedInputs"
          multiple
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Copy</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col>
        <pre>{{ services }}</pre>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog";
const CLONE_EXTRA = gql`
  mutation cloneExtra($input: CloneExtraInput!) {
    cloneExtra(input: $input) {
      id
      name
    }
  }
`;
export default {
  name: "clone-extra",

  props: {
    services: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: () => true,
    },
    value: {
      type: Object,
      default: () => null,
    },
    extras: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      debug: false,
      selectedServiceIds: [],
      newName:
        this.value && this.value.name
          ? `${this.value.name} Copy`
          : "New Name Extra",
      eid: this.value ? this.value.eid : "",
      serviceId: this.value ? this.value.serviceId : "",
    };
  },

  computed: {
    selectableServices() {
      return this.services.filter((s) => !s.notInUse);
    },
    isValid() {
      return this.newName != "" && this.value && this.value.id != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.newName = newVal ? `${newVal.name} Copy` : "New Name Extra";
      this.eid = newVal ? newVal.id : "";
      this.serviceId = newVal ? newVal.serviceId : "";
      this.selectedServiceIds = [];
    },
  },

  methods: {
    onSave() {
      const input = {
        sourceId: this.serviceId,
        sourceIds:
          this.extras.length > 0 ? this.extras.map((e) => e.serviceId) : [],
        targetIds: [...this.selectedServiceIds],
        newName: this.newName,
        id: this.eid,
        ids: this.extras.length > 0 ? this.extras.map((e) => e.id) : [],
      };
      this.cloneExtra(input);
    },
    async cloneExtra(input) {
      try {
        const result = await this.$apollo.mutate({
          mutation: CLONE_EXTRA,
          variables: { input },
        });
        //console.log(result);
        if (result.data.cloneExtra.id) {
          this.$emit("complete", { ...result.data.cloneExtra });
        }
      } catch (error) {
        console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/extras/CloneExtra.vue